export default __webpack_public_path__ + "static/media/Cook.8fd2337c.svg";